module.exports = __webpack_public_path__ + "img/Paper-Note.17cb9233.svg";